import { Component } from "react";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";

class VendorDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { } = this.state;
    const VendorDetails = this.props.location.state != null ? this.props.location.state.VendorDetailShow
      : null;

      console.log("this.props.location.state--->",this.props.location.state)
      console.log("VendorDetails--->",VendorDetails)
    return (
      <>
        {VendorDetails && VendorDetails.PersonName &&
          <div className="p-1 bg-light border mb-2 d-flex text-left">

            {/* Vendor Details */}
            <div style={{ width: "450px" }}>
              <p className="m-0 fw-semibold">Vendor Details</p>

              <ul className="p-0 m-0" style={{ listStyle: "none" }}>
                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                  <span>Person Name</span>
                  <span>: {VendorDetails.PersonName || "-"}</span>
                </li>

                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                  <span>Company Name</span>
                  <span>: {VendorDetails.CompanyName || "-"}</span>
                </li>

                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                  <span>Email ID</span>
                  <span>: {VendorDetails.EmailID || "-"}</span>
                </li>

                <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                  <span>Mobile No.</span>
                  <span>: {VendorDetails.MobileNo || "-"}</span>
                </li>
              </ul>
            </div>

            {/* Team Member */}
            {VendorDetails.VendorMDName &&
              <div style={{ paddingLeft: "100px" }}>
                <p className="m-0 fw-semibold">&ensp;</p>

                <ul className="p-0 m-0" style={{ listStyle: "none" }}>
                  <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                    <span>Person Name</span>
                    <span>: {VendorDetails.VendorMDName}</span>
                  </li>

                  <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                    <span>Company Name</span>
                    <span>: {VendorDetails.CompanyName || "-"}</span>
                  </li>

                  <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                    <span>Email ID</span>
                    <span>: {VendorDetails.VendorMDEmaiId || '-'}</span>
                  </li>

                  <li style={{ display: "grid", gridTemplateColumns: "120px 1fr" }}>
                    <span>Mobile No.</span>
                    <span>: {VendorDetails.VendorMDMobileNo || '-'}</span>
                  </li>
                </ul>
              </div>
            }
          </div>
        }
      </>
    );
  }
}

export default withRouter(
  connect(null, {})(VendorDetails)
);
